import React, { useCallback, useState } from "react"
import { useDispatch } from 'react-redux';
import { LinearProgress, Typography } from "@mui/material"
import { useDropzone } from 'react-dropzone'
import { AuthenticatedLink } from "../authenticated-link";

import filesService from "../../services/filesService"
import purchasesInWorkService from "../../services/purchasesInWorkService";

export const DocumentRequest = (props) => {
    const [uploadProgress, setUploadProgress] = useState(0);
    const [uploadFailure, setUploadFailure] = useState(false);
    const [uploadFailureMessage, setUploadFailureMessage] = useState("");
    const dispatch = useDispatch();

    let document = props.document;

    const isDocumentReceived = document.IsDocumentReceived && !document.IsDocumentRerequested;
    const hasFile = document.FileName && !document.IsDocumentRerequested && !document.IsDocumentArchived;

    const onDrop = useCallback((acceptedFiles) => {
        acceptedFiles.forEach((file) => {
            upload(file);
        });
    }, [])
    const {getRootProps, getInputProps} = useDropzone({
        onDrop,
        noClick: isDocumentReceived,
        noDrag: isDocumentReceived,
        noKeyboard: isDocumentReceived,
    });

    const upload = (file) => {
        setUploadFailure(false);
        filesService.uploadFile(`/PurchaseWorkSessions/${props.purchaseId}/Documents/${document.Id}/files`, file,
            (event) => {
                const updatedProgress = Math.round((100 * event.loaded) / event.total);
                setUploadProgress(updatedProgress);
        },
            () => {
                purchasesInWorkService.getSinglePurchaseInWork(props.purchaseId)
                    .then((purchaseInWork) => {
                        const action = {
                            type: "PURCHASE_IN_WORK_UPDATED_SINGLE",
                            purchaseInWork: purchaseInWork
                        };
                        dispatch(action);
                    })
                    .catch((error) => {
                        console.log(error);
                    })

        },
            (event) => {
                setUploadFailure(true);
                setUploadFailureMessage(event.response.data.Message);
        })
    }

    const getFileNameByUrl = (url) => {
        if (url) {
            const paramArr = url.slice(url.indexOf('?') + 1).split('&');
            const params = {};
            paramArr.map(param => {
                const [key, val] = param.split('=');
                params[key] = decodeURIComponent(val);
            })
            return params['fileName'];
        }
    }

    return (
        <React.Fragment>
            <div {...getRootProps({className: `dropzone ${document.IsDocumentRerequested ? 'dropzone_rerequested' : ''} ${isDocumentReceived || hasFile ? 'dropzone_received' : ''}`})}>
                <input {...getInputProps()} />
                <Typography component="div" variant="overline" className="dropzone_header">
                    {document.Name}
                    {document.IsDocumentRerequested && <><br/><span className="dropzone_rerequested_badge">Требуется замена</span></>}
                    {isDocumentReceived && <><br/><span className="dropzone_received_badge">Подтверждено</span></>}
                </Typography>
                {document.IsDocumentRerequested && (
                    <div className="dropzone_comment">
                        <Typography component="div" variant="caption" className="dropzone_comment_label">Причина отклонения:</Typography>
                        <Typography component="div" variant="body2" className="dropzone_comment_text">{document.Comment || "-"}</Typography>
                    </div>
                )}
                {!isDocumentReceived && <Typography component="div" variant="caption" className="dropzone_caption">Переместите файл сюда или кликните для загрузки</Typography>}
                {uploadProgress > 0 && (
                    <LinearProgress className="dropzone_progress" variant="determinate" color={uploadFailure ? "error" : "primary"} value={uploadProgress} />
                )}
                {(isDocumentReceived || hasFile) && (
                    <div className="dropzone_success" onClick={(e) => e.stopPropagation()}>
                        <span>Загружено</span>
                        <br/>
                        {document.FileName && (
                            <AuthenticatedLink url={document.FileName}><small>{getFileNameByUrl(document.FileName)}</small></AuthenticatedLink>
                        )}
                    </div>
                )}
                {uploadFailure && (
                    <div className="dropzone_fail">{uploadFailureMessage}</div>
                )}
            </div>
		</React.Fragment>
    )
}
